
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { ElementStudioContext } from "./ElementStudioTabsAndPanels.vue";
import { configStore } from "@/store/store-accessor";

@Component({})
export default class ElementStudioHideControlInput extends Vue {
  @Prop()
  value!: string[] | undefined;

  @Inject("context") readonly context!: ElementStudioContext;

  get items() {
    return Object.keys(configStore.elements);
  }

  toggleControl(enabled: boolean) {
    if (enabled) {
      this.$emit("input", []);
    } else {
      this.$emit("remove");
    }
  }

  updateValue(value: string[]) {
    this.$emit("input", value);
  }
}
